import type { UIMessage } from "ai";
import { dedupeUiMessagesForApiRequest } from "./dedupeUiMessagesForApiRequest";

/**
 * Mastra write assistants persist thread history server-side. Posting the full
 * client transcript on every turn duplicates provider item ids (e.g. after
 * approve/decline) and breaks the next user message.
 */
export function narrowUiMessagesForMastraThreadChat(messages: UIMessage[]): UIMessage[] {
  const deduped = dedupeUiMessagesForApiRequest(messages);
  if (deduped.length === 0) return deduped;

  const trailing: UIMessage[] = [];
  for (let i = deduped.length - 1; i >= 0; i--) {
    const message = deduped[i];
    if (message?.role !== "user") break;
    trailing.unshift(message);
  }
  if (trailing.length > 0) return trailing;

  return deduped;
}
